<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-top">
        <div class="brand-block">
          <img class="footer-logo" src="../../../public/custom/images/footer-logo.svg" alt="Logo image">
          <div class="brand-description">{{ $t('message.footer.tagline') }}</div>
        </div>
        <div class="auth-actions">
          <template v-if="isAuthorized">
            <div class="profile-img" @click="$router.push({ name: 'profile' })">{{ parsedUserName }}</div>
            <div class="footer-auth-btn-wrap footer-auth-btn-wrap--narrow">
              <base-button
                :text="$t('message.header.signOutBtn')"
                class="auth-button"
                @click="signOut()"
              />
            </div>
          </template>
          <template v-else>
            <div class="footer-auth-btn-wrap footer-auth-btn-wrap--register">
              <base-button
                :text="$t('message.header.register')"
                class="auth-button"
                @click="signUp()"
              />
            </div>
            <div class="footer-auth-btn-wrap footer-auth-btn-wrap--narrow">
              <base-button
                :text="$t('message.header.signInBtn')"
                class="auth-button sign-in-btn"
                @click="$router.push({ name: 'SignIn' })"
              />
            </div>
          </template>
        </div>
      </div>
      <div class="footer-middle">
        <div class="footer-service">
          <span>{{ $t('message.footer.serviceTitle') }}</span>
          <!-- <img src="../../../public/custom/images/arrow-down.svg" alt="Arrow down image"> -->
        </div>
        <div class="footer-content">
          <div class="links-columns">
            <div class="links-column">
              <router-link class="footer-link" v-for="link in firstColumnLinks" :key="link.textKey" :to="link.to">
                {{ $t(link.textKey) }}
              </router-link>
            </div>
            <div class="links-column">
              <router-link class="footer-link" v-for="link in secondColumnLinks" :key="link.textKey" :to="link.to">
                {{ $t(link.textKey) }}
              </router-link>
            </div>
          </div>
          <div class="social-block">
            <div class="social-links">
              <a target="_blank" class="social-link" v-for="link in socialsList" :key="link.iconName" :href="link.href">
                <img class="social-link-img" :src="require(`../../../public/custom/images/social/${link.iconName}.svg`)" alt="Social icon">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <a
          class="license-title"
          :href="registryIncludeLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('message.footer.license.title') }}
        </a>
        <span class="license-text">
          {{ $t('message.footer.license.text') }}
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
import BaseButton from '../base/BaseButton.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  components: {
    BaseButton
  },
  data() {
    return {
      firstColumnLinks: [
        {
          textKey: 'message.footer.links.about',
          to: { name: 'about' }
        },
        {
          textKey: 'message.footer.links.contacts',
          to: { name: 'contacts' }
        },
        {
          textKey: 'message.footer.links.news',
          to: { name: 'news' }
        },
        {
          textKey: 'message.footer.links.personalDataPolicy',
          to: { name: 'documentsActive' }
        }
      ],
      secondColumnLinks: [
        {
          textKey: 'message.footer.links.docs',
          to: { name: 'documentsActive' }
        },
        {
          textKey: 'message.footer.links.legal',
          to: { name: 'legislation' }
        },
        {
          textKey: 'message.footer.links.justice',
          to: { name: 'arbitration' }
        },
        {
          textKey: 'message.footer.links.questions',
          to: { name: 'questions' }
        }
      ],
      socialsList: [
        {
          href: 'https://t.me/kapusta_official',
          iconName: 'Telegram'
        },
        {
          href: 'https://www.instagram.com/kapusta.by/?igsh=MThvb3FvcGNieWxraw%3D%3D&utm_source=qr#',
          iconName: 'instagram'
        },
        {
          href: 'https://www.tiktok.com/@kapustaby?_t=8jK3Puqw1eX&_r=1',
          iconName: 'tik-tok'
        },
        {
          href: 'https://msng.link/o?375259080808=vi',
          iconName: 'Viber'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['profile']),
    registryIncludeLink() {
      return `${process.env.BASE_URL}static/registryInclude.pdf`
    },
    isAuthorized() {
      return this.profile?.role
    },
    parsedUserName() {
      if (this.isAuthorized) {
        return (
          this.profile.name_ru?.given_name_ru.slice(0, 1) +
          this.profile.name_ru?.family_name_ru.slice(0, 1)
        )
      }
      return ''
    }
  },
  methods: {
    signUp() {
      this.$router.push({ name: 'msi' })
    },
    async signOut() {
      await localStorage.removeItem('token')
      await this.$store.dispatch('purgeProfile')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 60px 0 32px;
  background-color: #f9f9f9;
  box-sizing: border-box;
}

.footer-container {
  @include base-page-container;

  flex-direction: column;
}

.footer-top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 48px;
}

.brand-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-logo {
  width: 150px;
  height: 31px;
}

.brand-description {
  color: #000;
  font-weight: 400;
  font-size: 16px;
  line-height: 18.4px;
}

.auth-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.profile-img {
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f49332;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: white;
  border-radius: 50%;
  cursor: pointer;
}

.footer-auth-btn-wrap {
  height: 40px;
  box-sizing: border-box;
}

.footer-auth-btn-wrap--narrow {
  width: 104px;
}

.footer-auth-btn-wrap--register {
  width: max-content;
  min-width: 104px;
}

.sign-in-btn {
  @include secondary-btn;
}

.footer-middle {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 48px;
}

.footer-service {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  width: fit-content;
  color: #000;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
}

.footer-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.links-columns {
  width: calc(100% - 230px);
  max-width: 1120px;
  display: grid;
  grid-template-columns: repeat(2, minmax(240px, 1fr));
  gap: 24px 80px;
}

.links-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.footer-link {
  color: #000;
  text-decoration: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 18.4px;
}

.social-block {
  flex-shrink: 0;
}

.social-links {
  display: flex;
  gap: 16px;
}

.social-link {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #fff;
  transition: transform 0.2s ease;
  border-radius: 50%;
}

.social-link:hover {
  transform: translateY(-2px);
}

.social-link-img {
  width: 20px;
  height: 20px;
}

.footer-bottom {
  width: 100%;
  color: rgba(0, 0, 0, 0.56);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}

.license-title {
  color: #41bf7b;
  text-decoration: none;
}

@media screen and (max-width: 1140px) {
  .footer {
    padding: 48px 0 28px;
  }

  .footer-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  .footer-content {
    flex-direction: column;
    gap: 24px;
  }

  .links-columns {
    width: 100%;
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

@media screen and (max-width: 640px) {
  .auth-actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .footer-auth-btn-wrap,
  .footer-auth-btn-wrap--narrow,
  .footer-auth-btn-wrap--register {
    width: 100%;
  }

  .profile-img {
    align-self: center;
  }

  .footer-service {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>